export default "__VITE_ASSET__BBOgSQfS__"